// extracted by mini-css-extract-plugin
module.exports = {"plus-button":"PMRTGz"};